import {
  GetFeedbackDTO,
  GetFeedbackResponceDTO,
  ResolveAlert,
  SetAlertTypeDTO,
} from ".";
import { ALERTS, ISetAlertByTypeAndResidentSuccess } from "../alerts/types";

import { ResolveAlertType } from "./types";

export function getFeedbackByAlertTypeRequest(
  value: GetFeedbackDTO
): ResolveAlertType {
  return {
    type: ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST,
    payload: value,
  };
}
export function getFeedbackByAlertTypeSuccess(
  value: GetFeedbackResponceDTO
): ResolveAlertType {
  return {
    type: ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS,
    payload: value,
  };
}
export function getFeedbackByAlertTypeFailure(value: any): ResolveAlertType {
  return {
    type: ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE,
    payload: value,
  };
}

export function setAlertByTypeRequest(
  value: SetAlertTypeDTO
): ResolveAlertType {
  return {
    type: ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST,
    payload: value,
  };
}
export function setAlertByTypeSuccess(
  value: ResolveAlert
): ISetAlertByTypeAndResidentSuccess {
  return {
    type: ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS,
    payload: value,
  };
}
export function setAlertByTypeFailure(value: any): ResolveAlertType {
  return {
    type: ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE,
    payload: value,
  };
}
